import { rem } from 'polished'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import ProgressBar from './ProgressBar'

import LinePaperclipIcon from 'LuxKit/Icons/line/LinePaperclipIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

const Root = styled(Group)`
  border-radius: ${props => props.theme.borderRadius.S};
  padding: ${rem(12)};
  background-color: ${props => props.theme.palette.neutral.default.seven};
`

const MainSection = styled(Group)`
  flex: 1;
`

const ProgressBarContainer = styled.div`
  padding-block: ${rem(8)};
`

interface Props {
  filename: string
  progress: number
}

function FileUploadPreview({ filename, progress }: Props) {
  return (
    <Root direction="horizontal" gap={12} verticalAlign="center" fullWidth>
      <LinePaperclipIcon size="XS" colour="neutral-two" />
      <MainSection direction="vertical" gap={4}>
        <Group direction="horizontal" gap={4} verticalAlign="baseline">
          <FormattedMessage
            id="7jYMJ5ARMRIh1FGCxxJp"
            defaultMessage="{filename} <caption>· Uploading…</caption>"
            description="File name with uploading status indicator during document upload"
            values={{
              filename: <BodyText variant="large" lineClamp={1}>{filename}</BodyText>,
              caption: (chunks) => <Caption variant="medium" colour="neutral-three">{chunks}</Caption>,
            }}
          />
        </Group>
        <ProgressBarContainer>
          <ProgressBar percentage={progress} />
        </ProgressBarContainer>
      </MainSection>
    </Root>
  )
}

export default FileUploadPreview
